/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
	Button,
	Checkbox,
	Image,
	Input,
	Select,
	Spin,
	Table,
	Tooltip,
	Dropdown,
	Empty,
} from 'antd';
import { MoreOutlined, DownCircleOutlined } from '@ant-design/icons';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
	getEmployeeCostAction,
	paginateEmployeeCostAction,
	updateEmployeeCost,
} from 'redux/action/employeeCostAction';
import { getEmployeeCostColumnAction } from 'redux/action/employeeCostColumnSlice';
import { AppDispatch } from 'redux/store';
import {
	ClockSvg,
	SortSvgBottom,
	SortSvgTop,
	SyncNowSvg,
} from 'utils/svgs';
import {
	checkPermission,
	convertToHyphenCase,
	hasText,
	toastText,
} from 'utils/utils';
import SearchAndFilter from '../SearchAndFilter';
import styles from './index.module.scss';
import './index.scss';
import { useNavigate, useSearchParams } from 'react-router-dom';
// import { payPeriodOptionsAction } from 'redux/action/payPeriodAction';
import {
	clearEmployeeCostRedux,
	updateEmployeeCostValue,
} from 'redux/slice/employeeCostSlice';
import { Loader } from 'components/Global';
import { useDebounce } from 'use-debounce';
import { getApi, putApi } from 'redux/apis';
import { NumericFormat } from 'react-number-format';
import dayjs from 'dayjs';
import MessageModal from 'components/Global/MessageModal';
import { getConfiguration } from 'redux/action/configurationAction';
import { EmployeeConfigModal } from '../EmployeeConfigModal';
import { EmployeeEditModal } from '../EmployeeEditModal';
import { customerOptionsAction } from 'redux/action/customerAction';
import { classAction, classOptionsAction } from 'redux/action/classAction';
import { PercentageOutlined, EditOutlined } from '@ant-design/icons';
import { ImportEmployeeCostCsvModal } from '../ImportEmployeeCostValueModal';
import { companyAbortController } from 'utils/abortController';
import axios from 'axios';
import Ellipse from 'components/Global/Ellipse';
import WrappingEllipse from 'components/CostAllocation/Ellipse';

const TestTable = (props: any) => {
	const {
		onChangePayPeriod,
		onChangeSearchValue,
		handleInactive,
		includeInactive,
		onChangeCostValue,
		showEmployeeWithAllocationConfig,
		onChangeShowEmployeeWithAllocationConfig,
		openEmployeeCostModal,
		onCloseEmployeeCostModal,
		handleShowPayPeriodCreationRefresh,
		showPayPeriodCreationRefresh,
		handleShowEmployeeCostRefresh,
		showEmployeeCostRefresh,
		isTableLoading,
		setIsTableLoading,
	} = props;

	const { Column } = Table;
	const dispatch = useDispatch<AppDispatch>();

	const navigate = useNavigate();

	const tableRef = useRef<any>(null);
	const scrollPositionRef = useRef<number>(0);

	const {
		data,
		count,
		payPeriodId: currentDatePayPeriodId,
		hasEmployeeData,
		notIncludedEmployeeIds,
	} = useSelector((state: any) => state?.employeeCosts);
	const { data: sectionWiseFields } = useSelector(
		(state: any) => state?.employeeCostColumns
	);

	const payrollMethod = useSelector(
		(state: any) => state?.companies?.configurations?.payrollMethod
	);

	const { closingDate } = useSelector((state: any) => state?.closingDate);

	const [queryParams, setQueryParams] = useSearchParams();

	const [payPeriodId, setPayPeriodId] = useState<string | null>(
		queryParams.get('payPeriodId') || localStorage.getItem('payPeriod')
	);
	const [isNewPayPeriod, setIsNewPayPeriod] = useState<string | null>(
		queryParams.get('isNewPayPeriod')
	);

	const [searchValue, setSearchValue] = useState('');
	const [debounceSearchValue] = useDebounce(searchValue, 300);
	const [hasInitialData, setHasInitialData] = useState(false);
	// const [loadingMore, setLoadingMore] = useState(false);

	// const tableRef = useRef<HTMLDivElement>(null);
	const finalTotalColumnId = useRef(Math.random());
	// const [isInViewPort, setIsInViewPort] = useState<boolean>(false);
	const [employeeData, setEmployeeData] = useState<any[]>([]);

	const [columns, setColumns] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);

	// const [isLoading, setIsLoading] = useState(false);
	const [isConfigModalOpen, setISConfigModalOpen] = useState(false);
	const [selectedEmployeeConfig, setSelectedEmployeeConfig] =
		useState<any>(null);

	// ENG-363 (Item 8): edit employee name + active status from the EC grid.
	const [isEmployeeEditModalOpen, setIsEmployeeEditModalOpen] = useState(false);
	const [selectedEmployeeForEdit, setSelectedEmployeeForEdit] = useState<{
		id: string;
		fullName: string;
		isActiveInApp: boolean;
	} | null>(null);

	const { optionData: payPeriods, isPayPeriodOptionFetched } = useSelector(
		(state: any) => state?.payPeriods
	);
	const isPayPeriodLength: any = useSelector(
		(state: any) => state?.payPeriods?.isPayPeriodLength
	);

	const [isAccountClosed, setIsAccountClosed] = useState<boolean>(false);
	const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
	const [isPayPeriodTourOpen, setIsPayPeriodTourOpen] = useState(false);

	const [totalCostRow, setTotalCostRow] = useState<any>(null);

	const selectedCompanyPermission = useSelector(
		(state: any) => state?.companies?.selectedCompanyDetails?.role?.permissions
	);

	const { selectedCompanyDetails } = useSelector(
		(state: any) => state.companies
	);

	const { data: configurationsData } = useSelector(
		(state: any) => state?.configuration
	);

	const isEditEmployeeCostPermission = checkPermission(
		selectedCompanyPermission,
		{
			permissionName: 'Employee Cost',
			permission: ['edit'],
		}
	);

	// ENG-363 (Item 8): the name/status edit modal writes Employee records, so it
	// is gated on Employees:edit (matching the backend PUT /employees/:id auth).
	const isEditEmployeePermission = checkPermission(selectedCompanyPermission, {
		permissionName: 'Employees',
		permission: ['edit'],
	});

	// ENG-363 fix pass 3: patch a single EC grid row in place after a modal edit,
	// instead of re-fetching. A re-fetch uses includeInactive=false and would drop
	// a newly-inactive employee from the response before Item 9 ever runs (even one
	// that still has values). This mirrors the backend per-period Item 9 rule
	// client-side: if the employee is now inactive AND every non-total cost value in
	// their current row is zero/empty, remove the row; otherwise keep it with the
	// updated name and (Inactive) tag. The `includeInactive` param is untouched.
	const applyEmployeeEdit = (
		employeeId: string,
		updated: { fullName: string; isActiveInApp: boolean }
	) => {
		// Non-total numeric cost columns are exactly the values Item 9 evaluates.
		const costFieldColumns = (columns as any[]).filter(
			(col: any) => col?.inputNumberField === 'Number' && !col?.isTotalField
		);

		setEmployeeData((prev) =>
			prev.reduce((acc: any[], row: any) => {
				if (row.employeeId !== employeeId) {
					acc.push(row);
					return acc;
				}

				const patchedRow = {
					...row,
					employeeName: updated.fullName,
					isActiveInApp: updated.isActiveInApp,
				};

				if (updated.isActiveInApp === false) {
					const hasNonZeroValue = costFieldColumns.some((col: any) => {
						const value = patchedRow[col.dataIndex];
						if (value === null || value === undefined) return false;
						const numeric = Number(String(value).replace(/,/g, '').trim());
						return !Number.isNaN(numeric) && numeric !== 0;
					});
					if (!hasNonZeroValue) {
						return acc; // genuinely empty + inactive → hide from the grid
					}
				}

				acc.push(patchedRow);
				return acc;
			}, [])
		);
	};

	const isConfigurationPermission = checkPermission(selectedCompanyPermission, {
		permissionName: 'Configurations',
		permission: ['edit', 'view', 'add', 'delete'],
	});

	const [showScrollToBottom, setShowScrollToBottom] = useState(false);
	const tableBodyRef = useRef<HTMLDivElement>(null);

	const [applySearch, setApplySearch] = useState(false);

	const [sort, setSort] = useState('asc');
	const [isSorting, setIsSorting] = useState(false);

	const colorArray = ['cell-fff', 'cell-f2f2f2', 'cell-e7eff8', 'cell-f3ede7'];

	const sortData = {
		showSorterTooltip: { title: '' },
		defaultSortOrder: 'ascend',
		sorter: () => {
			return null as any;
		},
		sortDirections: ['ascend', 'descend', 'ascend'],
		sortIcon: (data: any) => {
			return data.sortOrder === 'ascend' ? <SortSvgTop /> : <SortSvgBottom />;
		},
	};

	const saveScrollPosition = () => {
		const tableBody = document.querySelector('.ant-table-body');
		if (tableBody) {
			scrollPositionRef.current = tableBody.scrollLeft;
		}
	};
	const restoreScrollPosition = () => {
		const tableBody = document.querySelector('.ant-table-body');
		const tableHeader = document.querySelector('.ant-table-header');

		if (tableBody && tableHeader) {
			tableBody.scrollLeft = scrollPositionRef.current;
			tableHeader.scrollLeft = scrollPositionRef.current;
		}
	};
	// Get total employee-cost total

	const fetchEmployeeCostTotal: any = async () => {
		const requestKey = 'fetchEmployeeCostTotal';
		const { controller } = companyAbortController.createController(requestKey);
		try {
			const query: any = {
				companyId: localStorage.getItem('companyId'),
				payPeriodId: payPeriodId,
				search: debounceSearchValue,
				includeInactive,
				showEmployeeWithAllocationConfig,
			};

			// if (
			// 	!hasText(debounceSearchValue)
			// ) {
			// 	delete query.search;
			// }

			const employeeCostData = await getApi(
				`/employee-cost/total`,
				query,
				controller.signal
			);
			companyAbortController.cleanupRequest(requestKey);
			return employeeCostData?.data?.data;
		} catch (error: any) {
			if (axios.isCancel(error) || error?.name === 'CanceledError') {
				// Optionally return or ignore
				return;
			}
			navigate('/unauthorized');
		}
	};

	useEffect(() => {
		const currentCompanyId = localStorage.getItem('companyId');
		if (currentCompanyId) {
			// Initialize or update company in abort controller
			companyAbortController.changeCompany(currentCompanyId);
		}
	}, [selectedCompanyDetails?.companyId]);

	const closeModal = () => {
		setIsMessageModalOpen(false);
	};

	const openModal = () => {
		setIsMessageModalOpen(true);
		setIsPayPeriodTourOpen(false);
	};

	const handleMessageModalOk = () => {
		setIsMessageModalOpen(false);
		setIsPayPeriodTourOpen(true);
	};

	useEffect(() => {
		if (
			isPayPeriodLength == false &&
			localStorage.getItem('settings') === null
		) {
			openModal();
		}
	}, [isPayPeriodLength]);

	useEffect(() => {
		// dispatch(getEmployeeCostColumnAction()).then(() => {
		// 	// createFields();
		// });
		return () => {
			dispatch(clearEmployeeCostRedux());
		};
	}, []);

	useEffect(() => {
		if (notIncludedEmployeeIds) {
			setApplySearch(true);
		}
	}, [notIncludedEmployeeIds]);

	useEffect(() => {
		if (payPeriodId) {
			dispatch(
				getConfiguration({
					payPeriodId,
				})
			);
			dispatch(
				getEmployeeCostColumnAction({
					payPeriodId,
				})
			);
		}

		// if (payPeriodId) {
		// }
	}, [payPeriodId]);

	useEffect(() => {
		const handleScroll = () => {
			const tableBody = document.querySelector('.ant-table-body');
			if (tableBody) {
				const { scrollTop, scrollHeight, clientHeight } = tableBody;
				const isNearBottom = scrollTop + clientHeight >= scrollHeight - 100; // 100px threshold

				// Show button when not at bottom and has scrollable content
				setShowScrollToBottom(!isNearBottom && scrollHeight > clientHeight);
			}
		};

		// Add scroll listener to table body
		const tableBody = document.querySelector('.ant-table-body');
		if (tableBody) {
			tableBody.addEventListener('scroll', handleScroll);
			// Initial check
			handleScroll();
		}

		// Cleanup
		return () => {
			if (tableBody) {
				tableBody.removeEventListener('scroll', handleScroll);
			}
		};
	}, [employeeData, columns]);

	const scrollToBottom = () => {
		const tableBody = document.querySelector('.ant-table-body');
		if (tableBody) {
			tableBody.scrollTo({
				top: tableBody.scrollHeight,
				behavior: 'smooth',
			});
		}
	};

	useEffect(() => {
		if (selectedCompanyDetails && payPeriods && isPayPeriodOptionFetched) {
			let _payPeriodId: string | null = null;
			if (payPeriods.length) {
				if (
					payPeriods[payPeriods.length - 1].companyId ===
					selectedCompanyDetails.companyId
				) {
					_payPeriodId = payPeriodId;
					if (_payPeriodId) {
						const payPeriodData = payPeriods.find(
							(e: any) => e.id === payPeriodId
						);
						if (
							!payPeriodData ||
							payPeriodData.companyId != selectedCompanyDetails.companyId
						) {
							_payPeriodId = payPeriods[payPeriods.length - 1]?.id || null;
							// setPayPeriodId(payPeriods[payPeriods.length - 1]?.id || null);
						}
					} else {
						// setPayPeriodId(payPeriods[payPeriods.length - 1]?.id || null);
						_payPeriodId = payPeriods[payPeriods.length - 1]?.id || null;
					}
					if (_payPeriodId) {
						const _query: any = {
							payPeriodId: _payPeriodId as string,
						};

						if (queryParams.get('isNewPayPeriod') === 'true') {
							_query.isNewPayPeriod = 'true';
						}

						setQueryParams(_query);
						localStorage.setItem('payPeriod', _payPeriodId as string);
					}
					setApplySearch(true);
					setPayPeriodId(_payPeriodId);
					onChangePayPeriod && onChangePayPeriod(_payPeriodId);
					setTotalCostRow(null);
				}
			} else {
				if (_payPeriodId) {
					const _query: any = {
						payPeriodId: _payPeriodId as string,
					};

					if (queryParams.get('isNewPayPeriod') === 'true') {
						_query.isNewPayPeriod = 'true';
					}
					setQueryParams(_query);
					localStorage.setItem('payPeriod', _payPeriodId as string);
				}
				setApplySearch(true);
				onChangePayPeriod && onChangePayPeriod(_payPeriodId);
				setTotalCostRow(null);
			}
		}

		if (selectedCompanyDetails?.companyId) {
			dispatch(classAction());
			dispatch(classOptionsAction());
			dispatch(customerOptionsAction());
		}
	}, [selectedCompanyDetails, payPeriods, isPayPeriodOptionFetched]);

	useEffect(() => {
		if (payPeriodId && payPeriods) {
			const payPeriodData = payPeriods.find((e: any) => e.id === payPeriodId);
			if (payPeriodData && closingDate) {
				if (dayjs(payPeriodData.endDate) < dayjs(closingDate).endOf('day')) {
					setIsAccountClosed(true);
				} else {
					setIsAccountClosed(false);
				}
			}
		}
	}, [payPeriodId, payPeriods, closingDate]);

	useEffect(() => {
		const finalColumns: any = [
			{
				isSectionLastColumn: true,
				className: 'employee-name',
				cellColor: 'cell-fff',
				sectionId: '',
				sectionName: '',
				fieldId: '',
				fieldName: 'Employee Name',
				inputNumberField: 'Text',
				isCalculatorNeeded: false,
				isDollarNeeded: false,
				isHours: false,
				total: false,
				title: 'Employee Name',
				dataIndex: 'employeeName',
				key: Math.random(),
				width: 200,
				isHoursSetup: false,
				...sortData,
			},
		];

		// (payrollMethod === 'Percentage' && singleSection.no === 0)

		sectionWiseFields?.map((singleSection: any, sectionIndex: number) => {
			singleSection?.fields?.map((singleField: any, index: number) => {
				if (singleSection.no != 0 && singleField.isActive) {
					if (
						singleSection?.fields?.length === 1 &&
						singleField?.jsonId === 't1'
					) {
						return;
					}
					finalColumns.push({
						svg:
							sectionIndex === 0 && (index === 1 || index === 2) ? (
								<ClockSvg />
							) : null,
						cellWidth:
							sectionIndex === 0 && (index === 1 || index === 2) ? 130 : 90,
						className: convertToHyphenCase(singleField.name),
						sectionId: singleSection?.id,
						sectionName: singleSection?.sectionName,
						fieldId: singleField?.id,
						fieldName: singleField?.name,
						inputNumberField:
							singleField?.name == 'Employee Type'
								? 'Select'
								: singleField.jsonId.charAt(0) === 't'
									? 'Text'
									: 'Number',
						isTotalField: singleField.jsonId.charAt(0) === 't',
						isCalculatorNeeded:
							singleSection?.sectionName == 'Employee Type' ||
								payrollMethod === 'Percentage'
								? false
								: true,
						isDollarNeeded:
							singleSection?.sectionName == 'Employee Type' ? false : true,
						isHours:
							singleField?.name == 'Maximum allocate hours per year'
								? true
								: singleField?.name == 'Maximum Vacation/PTO hours per year'
									? true
									: false,
						total: false,
						title: singleField?.name,
						dataIndex: singleField?.id,
						cellColor: colorArray[sectionIndex],
						isSectionLastColumn:
							index === singleSection?.fields.length - 1 ? true : false,
						key: singleField?.id,
						width:
							singleField?.name == 'Employee Type'
								? 250
								: singleField?.name == 'Maximum allocate hours per year'
									? 210
									: singleField?.name == 'Maximum Vacation/PTO hours per year'
										? 250
										: 140,
						status: singleField?.active,

						isHoursSetup: singleSection?.no == 0,
					});
				}
			});
		});

		const totalColumn = {
			isSectionLastColumn: false,
			cellColor: 'cell-fff',
			className: 'totalLabourBurden',
			sectionId: '',
			sectionName: '',
			fieldId: '',
			fieldName: 'Total Labor Burden',
			inputNumberField: 'Text',
			isCalculatorNeeded: false,
			isDollarNeeded: false,
			isHours: false,
			total: true,
			title: 'Total Labor Burden',
			dataIndex: 'totalLaborBurden',
			key: finalTotalColumnId,
			width: 200,
			isHoursSetup: false,
			isTotalField: true,
		};

		finalColumns.push(totalColumn);

		setColumns(finalColumns);
	}, [sectionWiseFields]);
	// useEffect(() => {
	// 	dispatch(payPeriodOptionsAction());
	// }, []);

	useEffect(() => {
		if (applySearch) {
			getEmployeeCostData();
		}
	}, [
		// debounceSearchValue,
		payPeriodId,
		applySearch,
		payPeriodId,
		includeInactive,
		showEmployeeWithAllocationConfig,
		notIncludedEmployeeIds,
	]);

	// useEffect(() => {
	// 	if (applySearch && searchValue.length > 3) {
	// 		getEmployeeCostData();
	// 	}
	// }, [debounceSearchValue]);

	useEffect(() => {
		if (data && sectionWiseFields) {
			if (currentDatePayPeriodId) {
				setPayPeriodId(currentDatePayPeriodId);

				const _query: any = {
					payPeriodId: currentDatePayPeriodId as string,
				};

				if (queryParams.get('isNewPayPeriod') === 'true') {
					_query.isNewPayPeriod = 'true';
				}

				setQueryParams(_query);
				localStorage.setItem('payPeriod', currentDatePayPeriodId);
				onChangePayPeriod && onChangePayPeriod(currentDatePayPeriodId);
			}
			finalCalculation(data);
			getTotalCostValueRow();
			setHasInitialData(true);
			return;
		}

		if (!isTableLoading.current || !hasInitialData) {
			setEmployeeData([]);
			setTotalCostRow(null);
		}
	}, [data, sectionWiseFields, isTableLoading.current, hasInitialData]);

	// // Pagination
	// useEffect(() => {
	// 	const tableBody = document.querySelector('.ant-table-body');
	// 	tableBody?.addEventListener('scroll', scrollHandler);
	// 	return () => {
	// 		// Remove scroll event listener when component unmounts
	// 		tableBody?.removeEventListener('scroll', scrollHandler);
	// 	};
	// }, [data]);

	useEffect(() => {
		(async () => {
			if (employeeData.length < count) {
				// setLoadingMore(true);
				setCurrentPage((prev: any) => prev + 1);

				const requestKey = `paginateEmployeeCost-${currentPage}`;
				const { controller } =
					companyAbortController.createController(requestKey);

				const query = {
					page: currentPage + 1,
					limit: 10,
					// search: searchValue,
					sort: sort,
					payPeriodId,
					includeInactive,
					showEmployeeWithAllocationConfig,
					signal: controller.signal,
				};

				try {
					await dispatch(paginateEmployeeCostAction(query));
					companyAbortController.cleanupRequest(requestKey);
				} catch (error: any) {
					if (error.name === 'AbortError') {
						console.log('Pagination request aborted:', error.message);
						return;
					}
					console.error('Pagination error:', error);
				} finally {
					// setLoadingMore(false);
					companyAbortController.cleanupRequest(requestKey);
				}
			}
		})();
	}, [payPeriodId]);

	const getEmployeeCostData = async () => {
		const requestKey = 'getEmployeeCost';
		const { controller, requestId } =
			companyAbortController.createController(requestKey);

		// Only set loading if this is the latest request
		if (companyAbortController.isLatestRequest(requestKey, requestId)) {
			setIsTableLoading(true);
		}
		const query: any = {
			payPeriodId,
			page: 1,
			limit: -1,
			sort: sort,
			includeInactive,
			showEmployeeWithAllocationConfig,
			// search: debounceSearchValue,
			notIncludedEmployeeIds: notIncludedEmployeeIds?.join(','),
			signal: controller.signal,
		};

		// if (
		// 	!hasText(debounceSearchValue) ||
		// 	debounceSearchValue.toString().length < 3
		// ) {
		// 	delete query.search;
		// }

		if (!payPeriodId) {
			delete query.payPeriodId;
		}

		try {
			const res = await dispatch(getEmployeeCostAction(query));

			if (res?.payload?.error?.message === 'Invalid PayPeriod') {
				navigate('/login');
			}

			// if (res?.payload && !res?.payload?.error) {
			//  setHasInitialData(true);
			// }

			if (companyAbortController.isLatestRequest(requestKey, requestId)) {
				// Process results only if this is still the latest request
				if (res?.payload && !res?.payload?.error) {
					setHasInitialData(true);
				}
			}

			setCurrentPage(1);

			companyAbortController.cleanupRequest(requestKey);
		} catch (err: any) {
			if (err.name === 'AbortError') {
				// Request was aborted, do nothing
				console.log('Request aborted, new request in progress...');
				return;
			}

			console.error('API Error:', err);
			setIsTableLoading(false);
		} finally {
			// if (!controller.signal.aborted) {
			//  setIsTableLoading(false);
			//  setApplySearch(false);
			// }

			if (companyAbortController.isLatestRequest(requestKey, requestId)) {
				setIsTableLoading(false);
				setApplySearch(false);
			}
			companyAbortController.cleanupRequest(requestKey);
		}
	};

	// An AI-chat-confirmed write — a single cell or a bulk column change — can
	// alter rows this grid is currently displaying. ChatBubble has no way to
	// know this table's filters/sort/page, so it broadcasts a notice and the
	// table re-runs its OWN fetch above (see chatBubbleSlice.notifyDataChanged).
	//
	// Same guard order as the other two consumers of this notice
	// (CostAllocation/Table, pages/TimeActivity): scope, then company, then pay
	// period — so a change to another company or another period never pulls
	// this grid out from under the user mid-edit.
	const { dataChanged } = useSelector((state: any) => state?.chatBubble);
	useEffect(() => {
		if (!dataChanged || dataChanged.scope !== 'costAllocation') {
			return;
		}
		if (dataChanged.companyId !== localStorage.getItem('companyId')) {
			return;
		}
		if (dataChanged.payPeriodId && dataChanged.payPeriodId !== payPeriodId) {
			return;
		}
		// Paint a single-cell change straight away. For cost columns the column's
		// dataIndex IS the fieldId (see the column builder below), so the notice's
		// fieldId indexes the row directly. Rows live in local state here rather
		// than being read from the store each render, which is why this has to be
		// a setEmployeeData patch — same approach as applyEmployeeEdit above.
		const cell = dataChanged.cell;
		if (cell) {
			setEmployeeData((prev) =>
				prev.map((row: any) =>
					row.employeeId === cell.employeeId
						? { ...row, [cell.fieldId]: cell.value }
						: row
				)
			);
		}
		// Still refetch: the patch above covers the edited cell only, while the
		// write also moved that section's total and the labor burden column.
		getEmployeeCostData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dataChanged]);

	// //adding body to scroll to table body Infinite scroll
	// const scrollHandler = useCallback((event: any) => {
	// 	const { scrollTop, scrollHeight, clientHeight } = event.target;
	// 	if (scrollTop + clientHeight >= scrollHeight - 10) {
	// 		setIsInViewPort(true);
	// 	} else {
	// 		setIsInViewPort(false);
	// 	}
	// }, []);

	const handleChangeCostValue = (index: number, key: string, value: string) => {
		// Map filtered table index to original employee data index
		const originalIndex = employeeData.findIndex(
			(employee) =>
				employee.employeeId === filteredEmployeeData[index]?.employeeId
		);

		if (originalIndex === -1) {
			console.error('Employee not found in original data');
			return;
		}
		const tempCopy = JSON.parse(JSON.stringify(employeeData));
		// tempCopy[index][key] = hasText(value) ? value : 0;
		// dispatch(updateEmployeeCostValue({ index, key, value }));
		tempCopy[originalIndex][key] = hasText(value) ? value : 0;
		dispatch(updateEmployeeCostValue({ index: originalIndex, key, value }));
		setEmployeeData(tempCopy);
	};

	const changeHandler = async (
		index: number,
		key: string,
		value: string,
		method: string,
		isFromCalculator: boolean
	) => {
		// Map filtered table index to original employee data index
		const originalIndex = employeeData.findIndex(
			(employee) =>
				employee.employeeId === filteredEmployeeData[index]?.employeeId
		);

		if (originalIndex === -1) {
			console.error('Employee not found in original data');
			return;
		}
		// if (payrollMethod === 'Percentage') {
		const tempCopy = JSON.parse(JSON.stringify(employeeData));
		//calculation of fields
		let total = 0;
		// const sectionKey = tempCopy[index][`section_${key}`];
		const sectionKey = tempCopy[originalIndex][`section_${key}`];

		const section = sectionWiseFields.find(
			(singleSection: any) => singleSection.id === sectionKey
		);
		const totalCostSectionValueField = section.fields.find(
			(singleField: any) => singleField.jsonId === 't1'
		);
		for (const sectionField of section.fields) {
			if (sectionField.jsonId !== 't1' && sectionField.isActive) {
				// total += Number(tempCopy[index][sectionField.id]);
				total += Number(tempCopy[originalIndex][sectionField.id]);
			}
		}
		// tempCopy[index][totalCostSectionValueField.id] = total.toFixed(
		// 	configurationsData?.decimalToFixedAmount || 2
		// );
		tempCopy[originalIndex][totalCostSectionValueField.id] = total.toFixed(
			configurationsData?.decimalToFixedAmount || 2
		);

		dispatch(
			updateEmployeeCostValue({
				index: originalIndex,
				key: totalCostSectionValueField.id,
				value: total.toFixed(configurationsData?.decimalToFixedAmount || 2),
			})
		);
		finalCalculation(tempCopy);
		await dispatch(
			updateEmployeeCost({
				// employeeCostValueID: tempCopy[index][`value_${key}`],
				employeeCostValueID: tempCopy[originalIndex][`value_${key}`],
				value:
					Number(value).toFixed(
						configurationsData?.decimalToFixedAmount || 2
					) || '0.00',
				isCalculatorValue: isFromCalculator,
				// employeeId: tempCopy[index].employeeId,
				employeeId: tempCopy[originalIndex].employeeId,
				fieldId: key,
				payPeriodId,
				// configurationSectionId: tempCopy[index][`section_${key}`],
				configurationSectionId: tempCopy[originalIndex][`section_${key}`],
				isTotal: false,
			})
		);
		// update version 2 EmployeeCost table
		// await dispatch(
		// 	updateEmployeeCost({
		// 		employeeCostValueID:
		// 			tempCopy[index][`value_${totalCostSectionValueField.id}`],
		// 		value:
		// 			Number(total).toFixed(
		// 				configurationsData?.decimalToFixedAmount || 2
		// 			) || '0.00',
		// 		isCalculatorValue: isFromCalculator,
		// 		employeeId: tempCopy[index].employeeId,
		// 		fieldId: key,
		// 		payPeriodId,
		// 		configurationSectionId: tempCopy[index][`section_${key}`],
		// 		isTotal: true,
		// 	})
		// );
		await getTotalCostValueRow();

		const currentYear = new Date().getFullYear();
		await getApi('/dashboard/salary-by-customer-lambda-trigger', {
			companyId: localStorage.getItem('companyId'),
			year: currentYear,
		});
	};

	// For perform the sorting operation
	const performSortHandler = async (type: string) => {
		setIsSorting(true);
		setSort(type === 'ascend' ? 'asc' : 'desc');
		setCurrentPage(1);
		try {
			await dispatch(
				getEmployeeCostAction({
					page: 1,
					limit: -1,
					sort: type === 'ascend' ? 'asc' : 'desc',
					payPeriodId,
					includeInactive,
					showEmployeeWithAllocationConfig,
					notIncludedEmployeeIds: notIncludedEmployeeIds?.join(','),
				})
			);
		} catch (error) {
			console.error('Error sorting employee cost:', error);
		} finally {
			setIsSorting(false);
		}
	};

	// For handle the table change click
	const tableChangeHandler = (_: any, __: any, data: any) => {
		performSortHandler && performSortHandler(data.order);
	};

	//  for calculation of lastColumn
	const finalCalculation = async (_employeeData: any) => {
		const employeeDataCopy = JSON.parse(JSON.stringify(_employeeData));
		const fieldArray: any = [];
		sectionWiseFields.forEach((singleSection: any) => {
			if (singleSection.no !== 0) {
				// const fieldArray: any = [];
				singleSection.fields.forEach((singleField: any) => {
					if (singleField.jsonId === 't1') {
						fieldArray.push(singleField.id);
					}
				});
				// fieldObject[index] = fieldArray;
			}
		});
		_employeeData?.forEach((singleEmployee: any, index: number) => {
			let total = 0;
			fieldArray.forEach((singleField: any) => {
				total += Number(singleEmployee[singleField] || 0);
			});
			employeeDataCopy[index]['totalLaborBurden'] = total.toFixed(
				configurationsData?.decimalToFixedAmount || 2
			);
		});

		setEmployeeData(employeeDataCopy);
	};

	const getTotalCostValueRow = async () => {
		if (payPeriodId) {
			const totalCost = await fetchEmployeeCostTotal();
			if (totalCost && Object.keys(totalCost).length > 3) {
				setTotalCostRow(totalCost);
				return;
			}
			setTotalCostRow(null);
		}
	};

	const handleEmployeeModalClose = async () => {
		onCloseEmployeeCostModal && onCloseEmployeeCostModal(false);
		await getEmployeeCostData();
	};

	// Functional Spec §7 (WS-12) — per-cell sign flip on a whole cost column.
	// No confirmation modal (spec'd no-confirm; re-applying flips back).
	const handleConvertSigns = async (singleColumn: any) => {
		setIsTableLoading(true);
		saveScrollPosition();
		try {
			await putApi('/employee-cost/convert-signs', {
				companyId: localStorage.getItem('companyId'),
				payPeriodId: payPeriodId,
				fieldId: singleColumn.key,
				configurationSectionId: singleColumn.sectionId,
			});

			await getEmployeeCostData();
			await getTotalCostValueRow();
			// Restore scroll position after the refetched data renders
			setTimeout(() => {
				restoreScrollPosition();
			}, 0);

			const currentYear = new Date().getFullYear();
			await getApi('/dashboard/salary-by-customer-lambda-trigger', {
				companyId: localStorage.getItem('companyId'),
				year: currentYear,
			});
		} catch (error: any) {
			toastText(
				error?.response?.data?.message || 'Failed to convert column signs',
				'error'
			);
		} finally {
			setIsTableLoading(false);
		}
	};
	useEffect(() => {
		if (columns.length > 0) {
			// Use setTimeout to ensure DOM is updated
			setTimeout(() => {
				restoreScrollPosition();
			}, 0);
		}
	}, [columns]);

	const [seconds, setSeconds] = useState(60); // Starting countdown value
	/* 	const [timerId, setTimerId] = useState(null);
	const [showTempProcessRefreshFlag, setShowTempProcessRefreshFlag] =
		useState(true); */

	/* 	const startTimer = () => {
		if (timerId) {
			clearInterval(timerId); // Clear any existing timer
		}
		const newTimerId = setInterval(() => {
			setSeconds((prevSeconds) => {
				if (!showTempProcessRefreshFlag) {
					clearInterval(newTimerId);
					return prevSeconds;
				}

				if (prevSeconds === 0) {
					clearInterval(newTimerId); // Stop the timer when it reaches 0
					return 0;
				}

				if (
					seconds > 0 &&
					prevSeconds <= 40 &&
					prevSeconds % 10 === 0 &&
					showPayPeriodCreationRefresh &&
					!showEmployeeCostRefresh
				) {
					debugger;
					handlePayPeriodRefresh();
					handleShowPayPeriodCreationRefresh(false);
					setShowTempProcessRefreshFlag(false);y
					dispatch(
						getEmployeeCostAction({
							page: 1,
							limit: -1,
							sort: 'asc',
							payPeriodId: payPeriodId,
							includeInactive,
						})
					);
					getTotalCostValueRow();
					setSeconds(0);
					return 0;
				}

				if (
					seconds > 0 &&
					prevSeconds <= 40 &&
					prevSeconds % 10 === 0 &&
					!showPayPeriodCreationRefresh &&
					showTempProcessRefreshFlag &&
					showEmployeeCostRefresh
				) {
					handleEmployeeCostRefresh();
					handleShowEmployeeCostRefresh(false);
					setShowTempProcessRefreshFlag(false);
					setSeconds(0);
					return 0;
				}

				return prevSeconds - 1;
			});
		}, 1000);

		setTimerId(newTimerId as any); // Store the timer ID for clearing later
	};

	// Call startTimer when the component mounts (simulating componentDidMount)
	useEffect(() => {
		if (
			seconds === 60 &&
			!timerId &&
			(showPayPeriodCreationRefresh || showEmployeeCostRefresh)
		) {
			setSeconds(60);
			// You can adjust this logic as per your needs
			startTimer();
		}
	}, [showPayPeriodCreationRefresh, showEmployeeCostRefresh]); */

	const handlePayPeriodRefresh = async () => {
		const response = await getApi(
			'/employee-cost/importEmployeeCost-import-status',
			{
				companyId: localStorage.getItem('companyId'),
				type: 'Pay Period Creation',
			}
		);

		if (response.data.data) {
			if (response.data.data.status === 1) {
				handleShowPayPeriodCreationRefresh(false);
				toastText(response.data.data.message, 'success');

				setIsTableLoading(false);

				// const _query: any = {
				// 	openDrawer: 'true',
				// 	activeKey: 'Configurations',
				// };

				// if (queryParams.get('payPeriodId')) {
				// 	_query.payPeriodId = payPeriodId;
				// }

				// if (queryParams.get('isNewPayPeriod') === 'true') {
				// 	_query.isNewPayPeriod = 'true';
				// }

				// setQueryParams(_query);
			}
		}
	};

	/* const [timeLeft, setTimeLeft] = useState(120); // 2 minutes in seconds
	const [status, setStatus] = useState('pending'); // can be 'pending', 'completed'
	const [message, setMessage] = useState(''); // Dynamic message

	// Effect to handle the countdown timer and periodic status check
	useEffect(() => {
		if (timeLeft > 0 && status !== 'completed') {
			const timerId = setInterval(() => {
				if (showPayPeriodCreationRefresh) {
					handleEmployeeCostRefresh();
				}
				// Check the status and refresh
				setTimeLeft((prevTime) => prevTime - 10); // Decrease time by 10 seconds every interval
			}, 10000); // 10 seconds interval for checking status

			return () => clearInterval(timerId); // Cleanup on unmount
		} else if (timeLeft <= 0 && status !== 'completed') {
			setStatus('completed');
			setMessage('Your request is completed.');
		}
	}, [timeLeft, status]);

	// Update the message dynamically based on status and time left
	useEffect(() => {
		if (status === 'pending') {
			setMessage(
				`Your request is being processed. It will be completed in ${timeLeft} seconds.`
			);
		} else if (status === 'completed') {
			setMessage('Your request has been successfully completed.');
		}
	}, [status, timeLeft]); */

	const handleEmployeeCostRefresh = async () => {
		const response = await getApi(
			'/employee-cost/importEmployeeCost-import-status',
			{
				companyId: localStorage.getItem('companyId'),
				type: 'Import Employee Cost',
			}
		);

		if (response.data.data) {
			console.log('response.data.data.status: ', response.data.data.status);
			if (response.data.data.status === 1) {
				handleShowEmployeeCostRefresh(false);
				toastText(response.data.data.message, 'success');

				setIsTableLoading(false);

				const _query: any = {
					openDrawer: 'true',
					activeKey: 'Configurations',
				};

				if (queryParams.get('payPeriodId')) {
					_query.payPeriodId = payPeriodId;
				}

				if (queryParams.get('isNewPayPeriod') === 'true') {
					_query.isNewPayPeriod = 'true';
				}

				setQueryParams(_query);
			}
		}
	};

	useEffect(() => {
		if (debounceSearchValue !== undefined) {
			setTotalCostRow(null);
			getTotalCostValueRow();
		}
	}, [
		debounceSearchValue,
		payPeriodId,
		includeInactive,
		showEmployeeWithAllocationConfig,
	]);

	const filteredEmployeeData = useMemo(() => {
		if (!debounceSearchValue.trim() || debounceSearchValue.trim().length < 1) {
			return employeeData;
		}
		return employeeData.filter((employee) =>
			employee.employeeName
				?.toLowerCase()
				.includes(debounceSearchValue.toLowerCase())
		);
	}, [employeeData, debounceSearchValue]);

	const hasActiveFilters = Boolean(
		debounceSearchValue?.trim() ||
		includeInactive ||
		showEmployeeWithAllocationConfig
	);

	const CustomEmptyState = () => (
		<Empty
			image={Empty.PRESENTED_IMAGE_SIMPLE}
			description={
				(isTableLoading.current || isSorting)
					? null
					: hasActiveFilters
						? "No Employee Cost records match the selected filter criteria"
						: "No Employee Cost records are currently available"
			}
			style={{
				padding: '40px 20px',
				margin: '20px 0'
			}}
		/>
	);

	return (
		<>
			{employeeData && columns ? (
				<>
					<SearchAndFilter
						searchValue={searchValue}
						onChangeSearchValue={(value: any) => {
							setSearchValue(value);
							// setApplySearch(true);
							if (value.trim() !== debounceSearchValue.trim()) {
								setTotalCostRow(null);
							}
							onChangeSearchValue && onChangeSearchValue(value);
						}}
						// dateRangeDateHandler={(dateRange: any) =>
						// 	dateRangeDateHandler(dateRange)
						// }
						// payPeriodDateRange={payPeriodDateRange}
						// onSavePayPeriod={() => onSavePayPeriod()}
						onChangePayPeriodId={(id: any) => {
							setPayPeriodId(id);
							setQueryParams({
								payPeriodId: id,
							});
							setCurrentPage(1);
							setIsNewPayPeriod('false');
							localStorage.setItem('payPeriod', id);
							onChangePayPeriod && onChangePayPeriod(id);
							onChangeCostValue(false);
							setApplySearch(true);
						}}
						payPeriodId={payPeriodId}
						currentDatePayPeriodId={currentDatePayPeriodId}
						onSyncEmployee={() => {
							setPayPeriodId(null);
							localStorage.removeItem('payPeriod');
							onChangePayPeriod && onChangePayPeriod(null);
						}}
						closingDate={closingDate}
						handleInactive={(flag: any) => {
							handleInactive(flag);
							setApplySearch(true);
						}}
						includeInactive={includeInactive}
						showEmployeeWithAllocationConfig={showEmployeeWithAllocationConfig}
						isConfigurationPermission={isConfigurationPermission}
						onChangeShowEmployeeWithAllocationConfig={(flag) => {
							onChangeShowEmployeeWithAllocationConfig(flag);
							setApplySearch(true);
						}}
						handleShowPayPeriodCreationRefresh={
							handleShowPayPeriodCreationRefresh
						}
						isPayPeriodTourOpen={isPayPeriodTourOpen}
						onClosePayPeriodTour={() => setIsPayPeriodTourOpen(false)}
					/>

					<Table
						dataSource={
							totalCostRow
								? [...filteredEmployeeData, totalCostRow]
								: filteredEmployeeData
						}
						scroll={{ y: 'calc(88vh - 310px)' }}
						pagination={false}
						ref={tableRef}
						rowKey={(record: any) => {
							return record.employeeName;
						}}
						style={{ marginTop: '1rem' }}
						sticky
						className="employee-cost"
						onChange={tableChangeHandler}
						locale={{
							emptyText: <CustomEmptyState />
						}}
						footer={() => {
							return (
								<div className="employee-cost-footer-enhanced">
									<div
										style={{
											display: 'flex',
											justifyContent: 'space-between',
											alignItems: 'center',
										}}
									>
										<p className="employee-cost-footer">
											Total No. of Employee:{' '}
											{debounceSearchValue
												? filteredEmployeeData.length
												: count}
										</p>
										{/* {loadingMore && (
											<div
												style={{
													display: 'flex',
													alignItems: 'center',
													gap: '8px',
													color: '#1890ff',
													fontSize: '13px',
												}}
											>
												<Spin size="small" className="custom-spinner" />
												<span style={{ color: '#485949' }}>
													Loading more employees...
												</span>
											</div>
										)} */}
									</div>
								</div>
							);
						}}
						rowClassName={(record: any) => {
							if (record.employeeName === 'Total') {
								return 'employee-cost-row';
							}
							return '';
						}}
						loading={isTableLoading.current || isSorting}
					>
						{columns?.map((singleColumn: any) => {
							return (
								// isEmployeeCost &&
								// !singleColumn?.isHoursSetup && (
								<Column
									title={() => {
										return (
											<div className="employee-cost-column-title">
												<p>{singleColumn.svg}</p>

												{!singleColumn.isSectionLastColumn &&
													singleColumn.dataIndex !== 'totalLaborBurden' &&
													singleColumn.inputNumberField === 'Number' ? (
													<Dropdown
														menu={{
															onClick: ({ key }) => {
																if (key === 'convert-signs') {
																	handleConvertSigns(singleColumn);
																}
															},
															items: [
																{
																	key: 'convert-signs',
																	style: { fontSize: '12px' },
																	// Use old Ellipse for dropdown items
																	label: (
																		<Ellipse
																			message="Convert +/- signs"
																			maxLength={60}
																			isTooltip={true}
																			tooltipMessage="Convert +/- signs"
																		/>
																	),
																},
															],
														}}
														trigger={['hover']}
														disabled={!isEditEmployeeCostPermission}
													>
														<div
															style={{
																marginBottom: 0,
																cursor: isEditEmployeeCostPermission
																	? 'pointer'
																	: 'default',
															}}
														>
															{/* Use WrappingEllipse for main title */}
															<WrappingEllipse
																message={singleColumn.title}
																maxLength={60}
																maxLines={3}
																isTooltip={true}
																tooltipMessage={singleColumn.title}
															/>
														</div>
													</Dropdown>
												) : (
													<WrappingEllipse
														message={singleColumn.title}
														maxLength={60}
														maxLines={3}
														isTooltip={true}
														tooltipMessage={singleColumn.title}
													/>
												)}
											</div>
										);
									}}
									className={`${singleColumn.className} ${singleColumn.isSectionLastColumn && 'last-column'
										} ${singleColumn.cellColor || `cell-fff`} `}
									showSorterTooltip={{ title: '' }}
									defaultSortOrder={singleColumn.defaultSortOrder}
									sorter={singleColumn.sorter}
									sortDirections={singleColumn.sortDirections}
									sortIcon={singleColumn.sortIcon}
									dataIndex={singleColumn?.dataIndex}
									key={singleColumn?.key}
									fixed={singleColumn?.fieldName == 'Employee Name' && 'left'}
									align={singleColumn?.isTotalField ? 'right' : 'left'}
									width={singleColumn?.width}
									render={(value: string, employeeData: any, index: any) => {
										const calculatorData = {
											title: singleColumn?.fieldName,
											employee: employeeData?.employeeName,
										};
										return singleColumn?.inputNumberField === 'Select' ? (
											<Select
												placeholder="Select Employee Type"
												size="large"
												style={{ width: '100%' }}
												onChange={(value: any) => {
													changeHandler(
														index,
														singleColumn?.dataIndex,
														value,
														'select',
														false
													);
												}}
												disabled={
													!isEditEmployeeCostPermission || !employeeData?.status
												}
												value={value}
												options={[
													{
														value: 'salaried_exempt',
														label: 'Salaried Exempt',
													},
													{
														value: 'salaried_non_exempt',
														label: 'Salaried Non Exempt',
													},
													{ value: 'hourly', label: 'Hourly' },
												]}
											/>
										) : singleColumn?.inputNumberField === 'Number' ? (
											<div className={styles['dynamic-table__status']}>
												{singleColumn?.isHours == true ? (
													<Input
														value={value}
														size="large"
														style={{ fontSize: '12px' }}
														className={
															singleColumn.cellWidth === 130
																? 'width-130'
																: 'width-90'
														}
														defaultValue={value}
														disabled={
															!isEditEmployeeCostPermission ||
															!employeeData?.status
														}
														onChange={(event: any) => {
															changeHandler(
																index,
																singleColumn?.dataIndex,
																event?.target?.value,
																'hours',
																false
															);
														}}
													/>
												) : (
													<>
														{employeeData.employeeName !== 'Total' ? (
															<NumericFormat
																allowNegative={true}
																allowLeadingZeros={true}
																decimalScale={
																	configurationsData?.decimalToFixedAmount || 2
																}
																fixedDecimalScale={true}
																thousandSeparator=","
																customInput={Input}
																value={value}
																className={`${
																	singleColumn.cellWidth === 130
																		? 'width-130'
																		: 'width-120'
																}${
																	parseFloat(value) < 0
																		? ' negative-value'
																		: ''
																}`}
																min={0}
																disabled={
																	!isEditEmployeeCostPermission ||
																	!employeeData?.status ||
																	!payPeriodId ||
																	isAccountClosed
																}
																size="large"
																prefix={'$'}
																onChange={() => {
																	onChangeCostValue(true);
																}}
																onValueChange={(values: any) => {
																	handleChangeCostValue(
																		index,
																		singleColumn?.dataIndex,
																		values?.floatValue
																	);
																}}
																onBlur={() => {
																	changeHandler(
																		index,
																		singleColumn?.dataIndex,
																		value,
																		'number',
																		false
																	);
																}}
															/>
														) : (
															<NumericFormat
																value={value}
																thousandSeparator=","
																decimalScale={
																	configurationsData?.decimalToFixedAmount || 2
																}
																fixedDecimalScale={true}
																displayType="text"
																prefix="$"
																renderText={(_value) => (
																	<h4
																		className={`${
																			styles['dynamic-table-total']
																		}${
																			parseFloat(value) < 0
																				? ' negative-value'
																				: ''
																		}`}
																		style={{
																			textAlign: 'right',
																		}}
																	>
																		{_value ?? 0}
																	</h4>
																)}
															/>
														)}
													</>
												)}
											</div>
										) : (
											<div>
												{!(singleColumn.dataIndex === 'employeeName') ? (
													<NumericFormat
														value={value}
														thousandSeparator=","
														decimalScale={
															configurationsData?.decimalToFixedAmount || 2
														}
														fixedDecimalScale={true}
														displayType="text"
														prefix="$"
														renderText={(_value) => (
															<h4
																className={`${
																	styles['dynamic-table-total']
																}${
																	parseFloat(value) < 0
																		? ' negative-value'
																		: ''
																}`}
																style={{
																	textAlign: 'right',
																	fontSize: '12px',
																}}
															>
																{_value ? _value : '$0.00'}
															</h4>
														)}
													/>
												) : employeeData.employeeName != 'Total' ? (
													<div
														style={{
															display: 'flex',
															alignItems: 'center',
															justifyContent: 'space-between',
														}}
													>
														{/* ENG-363 fix pass (Bug 2): CAP is the source of truth
														for employee names — the misleading QBO external-link
														(navigation + QuickbooksEmployee icon) was removed. The
														edit pencil is now the name affordance. */}
														<div
															className={styles['dynamic-table__employee']}
														>
															<span
																className={
																	styles['dynamic-table__employee-name']
																}
															>
																{value}
															</span>{' '}
															<span
																className={
																	styles[
																	'dynamic-table__employee-name-inactive'
																	]
																}
															>
																{(!employeeData?.status || employeeData?.isActiveInApp === false) && '(Inactive)'}
															</span>
															<br />
															<span
																style={{ color: 'black', fontSize: '12px' }}
															>
																{employeeData?.hasEmployeeDirectAllocationConfig &&
																	'(Fixed %)'}
															</span>
														</div>
														<div
															style={{
																display: 'flex',
																alignItems: 'center',
																gap: '10px',
															}}
														>
															{isEditEmployeePermission && (
																<div
																	style={{ cursor: 'pointer' }}
																	onClick={() => {
																		setSelectedEmployeeForEdit({
																			id: employeeData.employeeId,
																			fullName: employeeData.employeeName,
																			isActiveInApp:
																				employeeData.isActiveInApp !== false,
																		});
																		setIsEmployeeEditModalOpen(true);
																	}}
																>
																	<Tooltip title="Edit employee name & status">
																		<EditOutlined />
																	</Tooltip>
																</div>
															)}
															<div
																style={{
																	cursor: 'pointer',
																}}
																// Only the first row is anchored — the payroll
																// tutorial spotlights one % icon, not every row's.
																{...(index === 0
																	? {
																		'data-tour-target':
																			'tutorial-fixed-percentage',
																	}
																	: {})}
																onClick={() => {
																	setISConfigModalOpen(true);
																	setSelectedEmployeeConfig({
																		id: employeeData.employeeId,
																		name: employeeData.employeeName,
																	});
																}}
															>
																<Tooltip title="Set employee direct allocation">
																	<PercentageOutlined />
																</Tooltip>
															</div>
														</div>
													</div>
												) : (
													<>
														<span
															className={styles['dynamic-table__employee-name']}
														>
															{value}
														</span>
													</>
												)}
											</div>
										);
									}}
								/>
								// )
							);
						})}
					</Table>
				</>
			) : (
				<div
					style={{
						position: 'fixed',
						top: 'calc(48vh + 70px)',
						left: 'calc(48vw + 150px)',
					}}
				>
					<Loader />
				</div>
			)}
			{isMessageModalOpen && (
				<MessageModal
					isModalOpen={isMessageModalOpen}
					handleCancel={closeModal}
					onOk={handleMessageModalOk}
					message="You need to create pay period first before using employee cost"
				/>
			)}
			{isConfigModalOpen ? (
				<EmployeeConfigModal
					open={isConfigModalOpen}
					onCloseModal={() => setISConfigModalOpen(false)}
					selectedEmployee={selectedEmployeeConfig}
					onConfigured={() => {
						setISConfigModalOpen(false);
						getEmployeeCostData();
					}}
					isClassRequiredForJournal={
						configurationsData?.isClassRequiredForJournal
					}
					isCustomerRequiredForJournal={
						configurationsData?.isCustomerRequiredForJournal
					}
				/>
			) : null}
			{isEmployeeEditModalOpen && selectedEmployeeForEdit ? (
				<EmployeeEditModal
					open={isEmployeeEditModalOpen}
					employee={selectedEmployeeForEdit}
					companyId={localStorage.getItem('companyId') || ''}
					onSave={(updated) => {
						applyEmployeeEdit(selectedEmployeeForEdit.id, updated);
						setIsEmployeeEditModalOpen(false);
						setSelectedEmployeeForEdit(null);
					}}
					onCancel={() => {
						setIsEmployeeEditModalOpen(false);
						setSelectedEmployeeForEdit(null);
					}}
				/>
			) : null}
			{openEmployeeCostModal ? (
				<ImportEmployeeCostCsvModal
					open={openEmployeeCostModal}
					onClose={() => handleEmployeeModalClose()}
				/>
			) : null}
			{showScrollToBottom && (
				<div
					style={{
						position: 'fixed',
						right: '60px',
						bottom: '160px',
						zIndex: 1000,
					}}
				>
					<button
						onClick={scrollToBottom}
						style={{
							width: '48px',
							height: '48px',
							borderRadius: '50%',
							border: '1px solid #344734',
							padding: 0,
							margin: 0,
							backgroundColor: '#fff',
							color: '#344734',
							cursor: 'pointer',
							boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							fontSize: '32px',
							fontWeight: 'bold',
							transition: 'all 0.3s ease',
							outline: 'none',
						}}
						onMouseEnter={(e) => {
							e.currentTarget.style.backgroundColor = '#344734';
							e.currentTarget.style.color = '#fff';
							e.currentTarget.style.transform = 'scale(1.1)';
							e.currentTarget.style.boxShadow =
								'0 6px 16px rgba(52, 71, 52, 0.3)';
						}}
						onMouseLeave={(e) => {
							e.currentTarget.style.backgroundColor = '#fff';
							e.currentTarget.style.color = '#344734';
							e.currentTarget.style.transform = 'scale(1)';
							e.currentTarget.style.boxShadow =
								'0 4px 12px rgba(0, 0, 0, 0.15)';
						}}
						title="Scroll to bottom"
					>
						<DownCircleOutlined />
					</button>
				</div>
			)}
		</>
	);
};

export default TestTable;
